import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsitePrivacyModeEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type WebsitePrivacyModeEventQuery = {
  __typename?: 'Query';
  eventById?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; hasEventPassword: boolean };
    settings: { __typename?: 'EventSettings'; id: string; privacyMode: Types.PrivacyModeType };
  } | null;
};

export const WebsitePrivacyModeEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsitePrivacyModeEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEventPassword' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'privacyMode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsitePrivacyModeEventQuery__
 *
 * To run a query within a React component, call `useWebsitePrivacyModeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePrivacyModeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePrivacyModeEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsitePrivacyModeEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsitePrivacyModeEventQuery, WebsitePrivacyModeEventQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsitePrivacyModeEventQuery, WebsitePrivacyModeEventQueryVariables>(WebsitePrivacyModeEventDocument, baseOptions);
}
export function useWebsitePrivacyModeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsitePrivacyModeEventQuery, WebsitePrivacyModeEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsitePrivacyModeEventQuery, WebsitePrivacyModeEventQueryVariables>(WebsitePrivacyModeEventDocument, baseOptions);
}
export type WebsitePrivacyModeEventQueryHookResult = ReturnType<typeof useWebsitePrivacyModeEventQuery>;
export type WebsitePrivacyModeEventLazyQueryHookResult = ReturnType<typeof useWebsitePrivacyModeEventLazyQuery>;
export type WebsitePrivacyModeEventQueryResult = Apollo.QueryResult<WebsitePrivacyModeEventQuery, WebsitePrivacyModeEventQueryVariables>;
